import styled from '@emotion/styled'

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
`
